import axios_instance from "../axios.config";

const ListStudentsForBonafideReport = async (newItem) => {
  try{
    const {
      class_id,
      section_id,
      academic_year_id,
    } = newItem;
  
    const payload = { class_id, section_id, academic_year_id };
    const response = await axios_instance.post(
      "/student/list-students-for-bonafide-report",
      payload
    );
    console.log(response);
    if (response?.data?.status === "SUCCESS") {
      return response.data;
    } else {
      return [];
    }
  } catch(err){
    console.error("Error fetching bonafide report student list:", err);
    return null;
  }
}

export {
  ListStudentsForBonafideReport
}